import type { CreateApplicationFormType, GeneralApplicationFormType } from '../applicationFormConfig'
import flyttLan from './flytt-lan'
import tillaggslan from './tillaggslan'
import nyttLan from './nytt-lan'
import type { ApplicationForm } from './form.types'

const forms: Record<GeneralApplicationFormType, ApplicationForm> = {
  newLoanApplication: nyttLan,
  transferLoanApplication: flyttLan,
  topupLoanApplication: tillaggslan,
}

export const getApplicationForm = (type: CreateApplicationFormType): ApplicationForm => {
  if (type === 'commitmentApplication') {
    throw new Error(`Ingen delad formulärdefinition för ${type}.`)
  }

  return forms[type]
}
